/**
 * @flow
 * @relayHash 7aba400715409e698560c6366668ec6a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteGovernorateMutationVariables = {|
  id: string
|};
export type DeleteGovernorateMutationResponse = {|
  +deleteGovernorate: {|
    +id: string
  |}
|};
export type DeleteGovernorateMutation = {|
  variables: DeleteGovernorateMutationVariables,
  response: DeleteGovernorateMutationResponse,
|};
*/


/*
mutation DeleteGovernorateMutation(
  $id: String!
) {
  deleteGovernorate(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteGovernorate",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "GovernorateModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteGovernorateMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteGovernorateMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteGovernorateMutation",
    "id": null,
    "text": "mutation DeleteGovernorateMutation(\n  $id: String!\n) {\n  deleteGovernorate(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '71e0932a5556277842895e8eb214dfa6';
module.exports = node;
